exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.canvas-wrapper[data-v-79679820] {\n  max-width: 200px;\n  padding: 5px;\n  overflow: auto;\n}\n[data-v-79679820]::-webkit-scrollbar {\n  -webkit-appearance: none;\n  width: 6px;\n  height: 6px;\n}\n[data-v-79679820]::-webkit-scrollbar-thumb {\n  border-radius: 4px;\n  background-color: #b7b8b9;\n  -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);\n}\n[data-v-79679820] .custom-multiselect .multiselect__content-wrapper {\n  box-shadow: 0px 15px 15px rgba(0, 0, 0, 0.35) !important;\n  border: 2px solid #e8e8e8;\n  border-width: 1px 2px 3px 2px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-79679820","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/process/processMultiSelectData.vue
// module id = 1169
// module chunks = 2